import { useQuery } from '@tanstack/react-query';
import { memberQueries } from '@/app/_query/memberQueries';

const useGetLoggedInfo = () => {
  return useQuery({
    ...memberQueries.loggedInfo(),
    select: (data) => data.data,
  });
};

export default useGetLoggedInfo;
